document.addEventListener('DOMContentLoaded', function() {
  var content = document.querySelector('.post-content.rte');
  var tocList = document.getElementById('article-toc-list');
  if (!content || !tocList) return;
  var headings = content.querySelectorAll('h2, h3');
  if (headings.length < 1) {
    var tocEl = document.querySelector('.article-toc');
    if (tocEl) tocEl.style.display = 'none';
    return;
  }
  headings.forEach(function(h, i) {
    var id = 'section-' + (i + 1);
    h.setAttribute('id', id);
    var li = document.createElement('li');
    li.className = h.tagName === 'H3' ? 'article-toc__item article-toc__item--sub' : 'article-toc__item';
    var a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = h.textContent;
    a.className = 'article-toc__link';
    li.appendChild(a);
    tocList.appendChild(li);
  });
  var toggle = document.querySelector('.article-toc__toggle');
  var nav = document.querySelector('.article-toc__nav');
  var icon = document.querySelector('.article-toc__icon');
  if (toggle) {
    toggle.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      nav.style.display = expanded ? 'none' : 'block';
      icon.textContent = expanded ? '+' : '\u2212';
    });
  }
});